import { useTheme } from "@emotion/react";
import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { SvgFullscriptIconDarkGreen } from "@shared/assets/logo";
import { l } from "@unauthenticated/shared/locales/i18n";

import pureEncapsulationsLogoDark from "./assets/pure-encapsulations-logo-dark.webp";
import pureEncapsulationsLogo from "./assets/pure-encapsulations-logo.svg";

import * as styles from "./ReferralPartnerSignUpBranding.styles";

interface Props {
  referralPartnerName: string;
}

// v1 uses bundled assets (pure encapsulations logo); will accept referralPartnerLogoUrl when multi-partner support lands.
const ReferralPartnerSignUpBranding = ({ referralPartnerName }: Props) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  return (
    <div css={styles.brandingRow} data-testid="referral-partner-sign-up-branding">
      <img
        src={isDarkMode ? pureEncapsulationsLogoDark : pureEncapsulationsLogo}
        alt={t(l.practitionerSignUp.referralPartner.logoAlt, { partnerName: referralPartnerName })}
        css={styles.partnerLogo}
        data-testid="partner-logo"
      />
      <div css={styles.poweredByBadge}>
        <SvgFullscriptIconDarkGreen css={styles.poweredByLogo} aria-hidden />
        <Typography variant="callout" isMarginless>
          {t(l.practitionerSignUp.referralPartner.poweredByFullscript)}
        </Typography>
      </div>
    </div>
  );
};

export { ReferralPartnerSignUpBranding };
